// extracted by mini-css-extract-plugin
module.exports = {"paywall-doctrine-lock":"doctrine-one-offer-lock_paywall-doctrine-lock__ymn84"};